import { PlatformComponentProps } from "@b2bportal/core-types";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface FlightSummaryLoadingComponentProps
  extends PlatformComponentProps {}

export const FlightSummaryLoading = (
  props: FlightSummaryLoadingComponentProps
) => null;
